export default {
  Dataset: 'Datasource',
  Home: 'Home',
  Map: 'Map',
  Service: 'Service',
  accept: ' Accept',
  access: 'Access',
  'access.apply_filter': 'Apply filter',
  'access.description': 'Share the datasource with your colleagues',
  'access.filter.all': 'All',
  'access.filter.equal': 'Equal',
  'access.filter.less': 'Less than',
  'access.filter.more': 'More than',
  access_datasets: 'Shared Datasources',
  access_maps: 'Shared Maps',
  access_services: 'Shared Services',
  reporting: 'Get reports',
  active: 'Active',
  'activity-log': 'Activity Log',
  add: 'Add',
  all: 'All',
  alphabetical: 'Alphabetical',
  apiKey: 'API Key',
  cancel: 'Cancel',
  change: 'change',
  'change-language': 'Language',
  'change-privacy': 'Change Privacy',
  column: 'Column',
  columns: 'Columns',
  comming_soon: 'Comming Soon',
  connect: 'Connect',
  'connection.connect': 'Connect',
  'connection.test': 'Test Connection',
  copied: 'Copied!',
  create: 'Create',
  csv: 'csv',
  'data.name': 'Datasource name',
  'data.tags': 'Datasource tags',
  'data.search': 'Search',
  'dataset.edit_dataset': 'Edit Datasource {name}',
  'dataset.enrichment.add_first': 'First Enrichment',
  'dataset.enrichment.add_new': 'Add New Enrichment',
  'dataset.enrichment.consumed': 'Consumed',
  'dataset.enrichment.consumption': 'Consumption',
  'dataset.enrichment.coord_format': 'Coordination Format',
  'dataset.enrichment.create': 'Start Proccess',
  'dataset.enrichment.filter_col': 'Filter Column',
  'dataset.enrichment.filter_type': 'Filter Type',
  'dataset.enrichment.full_address': 'Full Address',
  'dataset.enrichment.geom_col': 'Geometry Column',
  'dataset.enrichment.geom_col_name': 'geometry_column',
  'dataset.enrichment.geocode_col_name': 'geocode_column',
  'dataset.enrichment.in-use': 'In Use',
  'dataset.enrichment.inputs': 'Inputs',
  'dataset.enrichment.lat_col': 'Latitude Column',
  'dataset.enrichment.lon_col': 'Longitude Column',
  'dataset.enrichment.out-of-range': 'Records are Out of Range',
  'dataset.enrichment.out_col': 'Output Column Name',
  'dataset.enrichment.outputs': 'Outputs',
  'dataset.enrichment.projection': 'Projection',
  'dataset.enrichment.remain': 'Remain',
  'dataset.enrichment.rerun': 'Re-Run',
  'dataset.enrichment.schedule': 'Scheduling',
  'dataset.enrichment.precision': 'Set precision of search',
  datasets: 'datasets',
  datasource: 'datasource',
  date: 'Date',
  deactive: '{act}Active',
  de_active: 'Deactive',
  drag_drop: 'Drag & Drop',
  edit: 'Edit',
  'edit-data': 'Edit Data',
  'edit-property': 'Edit Properties',
  'edit.add_layer': 'Add Layer  +',
  'edit.add_service': 'Add Service  +',
  'edit.add_widget': 'Add Widget  +',
  'edit.basemap': 'Base Map',
  'edit.basemap.raster.google_sattellte': 'Google Satellite',
  'edit.basemap.raster.google_sattellte_label': 'Google Satellite with Label',
  'edit.basemap.raster.google_terrain': 'Google Terrain',
  'edit.basemap.raster.google_terrain_traffic': 'Google Terrain with Traffic',
  'edit.basemap.raster.osm_raster': 'OSM',
  'edit.basemap.raster.map': 'Map',
  'edit.basemap.raster_source': 'Raster',
  'edit.basemap.source': 'Source',
  'edit.basemap.style': 'Styles of Vector',
  'edit.basemap.style.Crow': 'Crow',
  'edit.basemap.style.Dove': 'Dove',
  'edit.basemap.style.Hawk': 'Hawk',
  'edit.basemap.style.Sparrow': 'Sparrow',
  'edit.basemap.style.Swallow': 'Swallow',
  'edit.data.add_column': 'Add Column',
  'edit.data.add_geo_column':
    'By typing a new name, a column with the same name and geometry type will be created.',
  'edit.data.add_row': 'Add Row',
  'edit.data.analysis': 'Analysis',
  'edit.data.create_map': 'Create Map',
  'edit.data.data': 'Data',
  'edit.data.datasource-name-title': 'Datasource Name',
  'edit.data.enrichment': 'Enrichment',
  'edit.data.enrichments': 'Enrichments',
  'edit.data.legend': 'Legend',
  'edit.data.map_view': 'Map View',
  'edit.data.metadata': 'Metadata',
  'edit.data.preview': 'Preview',
  'edit.data.property': 'Properties',
  'edit.data.save': 'Save',
  'edit.data.select_geom': 'Select Geometry Column',
  'edit.data.select_geom_column': 'Select Geo Column',
  'edit.data.select_geom_description':
    'In loading the datasource, the geometric information was not detected. In order to perform future operations, you need to specify the geometry column.',
  'edit.data.start_proccess': 'Start Proccess',
  'edit.data.style': 'Style',
  'edit.data.table_view': 'Table View',
  'edit.download': 'Download',
  'edit.download.1/1': '1:1',
  'edit.download.16/9': '16:9',
  'edit.download.aspectRatio': 'Aspect Ratio',
  'edit.download.format': 'Format',
  'edit.download.free': 'free',
  'edit.download.height': 'Height px',
  'edit.download.width': 'Width px',
  'edit.publish': 'Publish',
  'edit.publish.access-level': 'Set Access Level',
  'edit.publish.access-level.create': 'create',
  'edit.publish.access-level.delete': 'Delete',
  'edit.publish.access-level.edit': 'Edit',
  'edit.publish.access-level.read': 'Read',
  'edit.publish_config': 'publishing settings',
  editor_create_style_not_found: '',
  editor_update_style_not_found: '',
  email: 'Email',
  enrich_type: 'Enrichment Type',
  'enrichment.done': 'Operations completed successfully',
  'enrichment.failed': 'Operations failed',
  'enrichment.select_geo': 'Select Geometry',
  'enrichment.validation.address': 'Select Address Column',
  'enrichment.validation.export_column_name': 'Column name is repetitious',
  etc: 'etc',
  favourite: 'Favourites',
  'filePicker.drop-files-here': 'Drop file here',
  'filePicker.placeholder_with_drag': 'Choose a file or drag it here',
  'filePicker.placeholder_without_drag': 'Choose a file',
  filter: 'Filter',
  filters: 'Filters',
  'geo.feature': 'Features',
  geojson: 'geojson',
  geography: 'Geographical',
  geom_column: 'Geometry Column',
  gml: 'gml',
  goBack: 'Back',
  'greetings.actionCall': "Let's Go",
  'greetings.mainMessage': 'Hi{name}, Welcome to My.map!',
  'greetings.subMessage': 'Click to find out more about services.',
  'grid.cell_menu.add_row': 'Add new row',
  'grid.cell_menu.copy_value': 'Copy cell value',
  'grid.cell_menu.delete_row': 'Delete this row',
  'grid.cell_menu.edit-cell': 'Edit this cell',
  'grid.cell_menu.edit-row': 'Edit this Row',
  'grid.header_menu.add_column': 'Add new column',
  'grid.header_menu.delete_column': 'Delete this column',
  'grid.header_menu.edit_feature': 'Edit this geometry feature',
  'grid.header_menu.edit_name': 'Rename column',
  'grid.header_menu.edit_type': 'Change data type',
  'grid.header_menu.select_geom': 'Select geometry column',
  'grid.loading': 'Loading...',
  'grid.no_data': 'No rows to show!',
  id: 'ID',
  in_progress: 'In Progress',
  'intro.datasets.emptyMessage': 'Upload your Datasource',
  'intro.datasets.emptyStatus': 'No Datasource Available',
  'intro.datasets.emptySubMessage': 'Click to find out about uploading methods',
  'intro.datasets.error': 'No Datasource Found',
  'intro.datasets.new': 'New Datasource',
  'intro.datasets.select': 'Select Datasource',
  'intro.datasets.title': 'Datasources',
  'intro.maps.emptyMessage': 'Create your Map',
  'intro.maps.emptyStatus': 'No Map Available',
  'intro.maps.emptySubMessage': 'Click to find out about uploading methods',
  'intro.maps.error': 'No Map Found',
  'intro.maps.new': 'New Map',
  'intro.maps.title': 'Maps',
  'intro.services.emptyMessage': 'Select your Service',
  'intro.services.emptyStatus': 'No Service Available',
  'intro.services.emptySubMessage': 'Click to find out about uploading methods',
  'intro.services.error': 'No Service Found',
  'intro.services.new': 'New Service',
  'intro.services.title': 'Services',
  kml: 'kml',
  'layer-asc': 'Most Layers',
  'layer-desc': 'Least Layers',
  'layer.default': 'Default Layer',
  'layer.delete': 'Delete Layer',
  'layer.hide': 'Hide Layer',
  'layer.unhide': 'Show Layer',
  layers: 'Layers',
  limitation: 'Limitation',
  load_more: 'Load More',
  'log.time_interval': 'Time Interval',
  'log.time_interval_from': 'From',
  'log.time_interval_last_month': 'Last Month',
  'log.time_interval_last_season': 'Last Season',
  'log.time_interval_last_week': 'Last Week',
  'log.time_interval_last_year': 'Last Year',
  'log.time_interval_to': 'To',
  'log.time_interval_yesterday': 'Yesterday',
  'login.captcha': 'Captcha',
  'login.login': 'Log in!',
  'login.login-title': 'Login',
  'login.messages.signup.no-account': '',
  'login.messages.signup.signup-link': '',
  'login.password': 'Password',
  'login.password_confirm': 'password confirmation',
  'login.singin-title': 'signup',
  'login.username': 'Username',
  'login.validate.password': '',
  'login.validate.username': '',
  'login.with_otp': 'Login with One Time Password',
  'login.with_otp.enter_code': 'Please enter the code that sent to your phone:',
  'login.with_otp.enter_mobile': 'Please enter your phone number:',
  'login.with_otp.recieve_code': 'Recieve Code',
  'login.with_otp.remain_time': 'Time remaining until the code expires:',
  'login.with_otp.resend_code': 'Resend code',
  'login.with_otp.required': 'This field is required.',
  'login.with_otp.mobile_min_length':
    'Mobile number cannot be less than 11 digits.',
  'login.with_otp.mobile_not_valid': 'Mobile number is not valid.',
  'login.with_pass': 'Login with username and password',
  'management-access': 'Management Access',
  maps: 'maps',
  mobile: 'Mobile',
  my_datasets: 'My Datasources',
  my_maps: 'My Views',
  my_services: 'My Services',
  name: 'Name',
  new: 'Newest',
  'no-tag': 'no tag',
  no_data: 'No data found',
  numerical: 'Numerical',
  number_of_columns: 'Columns',
  number_of_rows: 'ٔRows',
  off: 'off',
  old: 'Oldest',
  on: 'on',
  open: 'Open',
  order: 'Order',
  owner: 'Owner',
  pending: 'Pending',
  'placeholder.email': 'example@example.com',
  'placeholder.search_dataset': 'Search in name of Datasources or tags',
  'placeholder.search_service': 'Search in name of Services or tags',
  'placeholder.search_view': 'Search in name of Map or tags',
  'placeholder.upload':
    'Upload File(.kml, .gml, .geojson, .json, .zip, .csv, .xslx).',
  preview: 'Preview',
  private: 'Private',
  'profile.account-types': '',
  'profile.account_type_title': 'account type',
  'profile.add_user': 'Add New User',
  'profile.admin_password': 'Admin password',
  'profile.cellphone': 'cell phone',
  'profile.change_password': 'Change Password',
  'profile.current_password': 'Current Password',
  'profile.deactive_user': 'Are you sure to {act}active user {name}?',
  'profile.deactive_user_warning': '{act}Activated user can be {oact}Activated',
  'profile.delete_user': 'Are you sure to delete user {name}?',
  'profile.delete_user_warning': 'Deleted user can not be recoverd',
  'profile.description.message':
    'In your profile you can change your name, avatar, email, and other informations.',
  'profile.edit_user': 'Edit User {name}',
  'profile.exit': 'Exit',
  'profile.firstname': 'Name',
  'profile.lastname': 'Last name',
  'profile.logout': 'Do you want to logout?',
  'profile.mail': 'Email',
  'profile.management': 'Management',
  'profile.new_password': 'New Password',
  'profile.notification': 'Notification',
  'profile.payment': 'Payment',
  'profile.private_profile': 'private profile',
  'profile.profile': 'Profile',
  'profile.public_profile': 'public profile',
  'profile.re_new_password': 'Repeat New Password',
  'profile.select_language': 'Select one language:',
  'profile.settings': 'Setting',
  'profile.user-types': 'personal-corporational',
  'profile.user_type_title': 'Role',
  'profile.validate.email': '',
  'profile.validate.mobile': '',
  'profile.validate.name': '',
  'profile.validate.role': '',
  public: 'Public',
  record: 'Record',
  regional_search: 'Regional Search',
  'regional_search.desc': 'Geographical Search in selected or drawn area',
  remove: 'Remove',
  restart: 'Restart',
  results: 'Results',
  role: 'Role',
  row: 'Row',
  rows: 'Rows',
  'rows-asc': 'Most Rows',
  'rows-desc': 'Least Rows',
  save: 'Save',
  search: 'Search',
  'search.desc': 'Search on Selected Datasource',
  'search.nearest': 'Search Nearestr Distance',
  select_datasource: 'Select Datasource',
  select_service: 'Select Service',
  select_widget: 'Select Widget',
  send: 'Send',
  'service.create': 'Create Service',
  'service.create_empty_view': 'Create Empty Map',
  'service.create_with_view': 'Create View',
  'service.create_with_widget_view': 'Create Map with Widget',
  'service.description': 'Service Description',
  'service.details': 'Service Details',
  'service.name': 'Service Name',
  'service.restart': 'Restart Service',
  'service.select_service_properties': 'Please enter service properties:',
  'service.select_service_type': 'Please select one of the services:',
  'service.select_view_widget':
    'If select any of services, you can create view with widget of that service:',
  'service.tags': 'Service Tags',
  'service.update': 'Update Service',
  'service.validation.filterable': 'Please enter service filters.',
  'service.validation.geom_column': '',
  'service.validation.name': 'Please enter service name.',
  'service.validation.searchfield': 'Please enter service searchfield.',
  'service.validation.selectable': 'Please enter service selects.',
  service_type: 'Service type',
  services: 'Services',
  settings: 'Settings',
  shapefile: 'shapefile',
  share: 'Share',
  'share.link': 'Access via Link',
  'share.link_deactive': 'Deactive Link',
  'share.link_warning': 'Others can see this link!',
  'share.private': 'Private(Default)',
  'share.private_warning': 'In this case, JUST you have access!',
  'share.access_to_map': 'Access to this map',
  'share.copy_link': 'Copy public link',
  'share.open_in_new_tab': 'Open in new tab',
  'share.iframe': 'Iframe code',
  'share.copy_iframe': 'Copy Iframe code',
  'share.desc':
    'To display the map, copy the code above and place it on the corresponding page.',
  'show-all': 'show all',
  'sidebar.dataset_settings.button.copy_dataset': 'Copy Datasource',
  'sidebar.dataset_settings.button.lock_dataset': 'Lock Datasource',
  'sidebar.dataset_settings.input.attributes_placeholder':
    'enter attribtes related to this data',
  'sidebar.dataset_settings.input.description_placeholder':
    'all the tourist attractions on Paris',
  'sidebar.dataset_settings.input.name_placeholder': 'Paris Map',
  'sidebar.dataset_settings.input.source_placeholder': 'enter source of data',
  'sidebar.dataset_settings.input.tags_placeholder': 'paris, tourism',
  'sidebar.view_settings.add_operation': 'Add Operations',
  'sidebar.view_settings.layer_management': 'Layer management',
  'sidebar.view_settings.layer_management.legend': 'Legend',
  'sidebar.view_settings.layer_management.open_by_default': 'open by default',
  'sidebar.view_settings.switch.isRTL': 'RTL Layout',
  'sidebar.view_settings.checkbox.compass': 'Compass',
  'sidebar.view_settings.checkbox.go_coord': 'Go to Coordinates',
  'sidebar.view_settings.checkbox.layer_management': 'Layer Management',
  'sidebar.view_settings.checkbox.my_location': 'My Location',
  'sidebar.view_settings.checkbox.print': 'Printer',
  'sidebar.view_settings.checkbox.public_search': 'Public Search',
  'sidebar.view_settings.checkbox.show_compass': 'Show compass',
  'sidebar.view_settings.checkbox.show_coord': 'Show coordinates',
  'sidebar.view_settings.checkbox.show_current_location':
    'show current location',
  'sidebar.view_settings.checkbox.show_go_coord': 'Show Go to Coordinates',
  'sidebar.view_settings.checkbox.show_layer_management':
    'Show Layer Management',
  'sidebar.view_settings.checkbox.show_legend': 'Show legend',
  'sidebar.view_settings.checkbox.show_my_location': 'Show My Location',
  'sidebar.view_settings.checkbox.show_print': 'Show Printer',
  'sidebar.view_settings.checkbox.show_public_search': 'Show Public Search',
  'sidebar.view_settings.checkbox.show_scale': 'Show scale',
  'sidebar.view_settings.checkbox.show_tool_bar': 'Show tool bar',
  'sidebar.view_settings.checkbox.show_zoom': 'Show zoom',
  'sidebar.view_settings.display_options': 'Display Options',
  'sidebar.view_settings.input.initial_zoom_level': 'Initial zoom level',
  'sidebar.view_settings.input.initial_zoom_level_placeholder': 'Default at 10',
  'sidebar.view_settings.input.tags': 'Map tags',
  'sidebar.view_settings.input.tags_placeholder': 'paris, tourism',
  size: 'Size',
  'size-asc': 'Most Volume',
  'size-desc': 'Least Volume',
  status: 'Status',
  'step.next': 'Next step',
  'style_editor.create_new_style': 'Create Style',
  'style_editor.update_style': 'Edit Style',
  'subview.dataset-add.add_empty_dataset': 'Add Empty Datasource',
  'subview.dataset-add.file-dir-url': 'Address of file or directory',
  'subview.dataset-add.input.database_name': 'Databse Name',
  'subview.dataset-add.input.driver': 'Driver',
  'subview.dataset-add.input.host': 'Host',
  'subview.dataset-add.input.password': 'Password',
  'subview.dataset-add.input.port': 'Port',
  'subview.dataset-add.input.table_name': 'Table Name',
  'subview.dataset-add.input.username': 'Username',
  'subview.dataset-add.subtitle':
    'Enrich your maps using data from various third-party sources and analyze better!',
  'subview.dataset-add.tab.log': 'Reports',
  'subview.dataset-add.tab.use_available_datasourses': 'Available DataSources',
  'subview.dataset-add.tab.use_cloud': 'Cloud Providers',
  'subview.dataset-add.tab.use_data-service': 'DataSources',
  'subview.dataset-add.tab.use_databse': 'Databases',
  'subview.dataset-add.tab.use_file': 'Upload',
  'subview.dataset-add.title': 'Create new Datasource',
  'subview.dataset-add.upload-local-files': 'upload local files',
  'subview.dataset.enrichment': 'New Enrichment',
  'subview.services-add': 'Create new Service from datset {datasourceName}',
  'subview.services-add.subtitle': 'Build your service.',
  'subview.services-add_layer': '',
  'subview.services-add_layer.subtitle': '',
  'subview.services-add_new': 'Create new service',
  'subview.services-add_new.subtitle': 'Build your service.',
  'subview.services-add_widget': '',
  'subview.services-add_widget.subtitle': '',
  'subview.services-edit': 'Edit service {serviceName}',
  'subview.services-edit.subtitle': 'Edit your service.',
  'table.activity': 'Activity',
  'table.optionMenu.name': 'Options',
  'table.section': 'Section',
  'table.status': 'Status',
  'table.time': 'Time',
  'table.upload_date': 'Upload Date',
  tags: 'Tags',
  text: 'Text',
  tiles: 'Tiles',
  'tiles.desc': 'Display Datasource on Map',
  'toaster.default.redirect_to_login': 'Redirecting to Login',
  'toaster.error.create_new_service': 'New Service created successfully!',
  'toaster.error.datasource_not_selected': 'Please select datasource first!',
  'toaster.error.editor_add_widget/layer_to_view':
    'Layer/Widget is added to view!',
  'toaster.error.editor_autocomplete_not_found': 'Nothing found!',
  'toaster.error.editor_get_column_not_found': 'Columns not found!',
  'toaster.error.editor_get_datasource_not_found': 'Datasourse not found!',
  'toaster.error.editor_get_nearest_not_found': 'Nearest not found!',
  'toaster.error.editor_get_row_not_found': 'Rows not found!',
  'toaster.error.editor_get_search_params_not_found':
    'Search params not found!',
  'toaster.error.editor_get_service_not_found': 'Services not found!',
  'toaster.error.editor_get_table_not_found': 'Table not found!',
  'toaster.error.editor_get_user_not_found': 'User not found!',
  'toaster.error.editor_get_view_not_found': 'Views not found!',
  'toaster.error.editor_identify_not_found': 'No information!',
  'toaster.error.editor_widget/layer_not_found': 'Layer/Widget Not found!',
  'toaster.error.enrich_type_not_selected': '',
  'toaster.error.loagin_failed.captcha': '',
  'toaster.error.login_failed': "There's a problem to login, try again.",
  'toaster.error.login_failed.email_not_found': 'Email Not Found',
  'toaster.error.login_failed.password_not_correct': 'Password is not correct',
  'toaster.error.my_location_error': '',
  'toaster.error.my_location_not_supported':
    'Geolocation is not supported by your browser',
  'toaster.error.profile.change_password':
    'Repeat of new password is not match!',
  'toaster.error.send_code': 'There was a problem sending the code; Try again.',
  'toaster.error.service_cant_update': "Unfortunately, Service Can't update",
  'toaster.error.service_not_selected': '',
  'toaster.error.service_type_not_selected':
    'Please select service type first!',
  'toaster.error.users_conflict': '',
  'toaster.error.wrong_code': 'The entered code is not correct.',
  'toaster.error.enrichment_removed':
    'An error occured trying to remove enrichment',
  'toaster.error.enrichment_started_again':
    'Error occured trying to start enrichment again',
  'toaster.error.db_connection_error':
    'Error occured trying to connect to database',
  'toaster.error.creating_enrichment': 'Error creating enrichment',
  'toaster.success.profile.add_new_user': 'New user added succesfully!',
  'toaster.success.profile.change_password':
    'Password has changed succesfully!',
  'toaster.success.profile.delete_user': 'User deleted succesfully!',
  'toaster.success.service_updated': 'Service Updated Successfully.',
  'toaster.success.shared': 'Shared Successfully.',
  'toaster.success.updated': 'Updated Successfully.',
  'toaster.success.thumbnail_changed': 'Thumbnail changed',
  'toaster.success.enrichment_removed': 'Enrichment removed successfully',
  'toaster.success.enrichment_started_again': 'Enrichment started again',
  'toaster.success.db_connection_started':
    'Connection to database started. Please be patient.',
  'toaster.success.connection_test': 'Successfully tested connection',
  'toaster.warning.creating_tiles':
    'To Style, Please wait until tiles are created...',
  'toaster.warning.invalid_coordinates': 'Invalid coordinates!',
  'toaster.update.uploading': 'uploading',
  'toaster.update.upload_successful': 'File uploaded successfully',
  'toaster.update.upload_failed': 'Upload failed',
  updated: 'Updated',
  user: 'user',
  'user-management': 'User Management',
  'view.description': 'Description',
  'view.name': 'Map Name',
  'view.decription': 'Description',
  'view.no_decription': 'No description',
  'view.no_name': 'Untitled',
  'view.tiles.identify.attributes.not_found': 'no data available.',
  'view.tiles.identify.attachment.not_found': 'no attachments for this layer.',
  'view.service.add_select_datasource':
    'You can upload new datasourse or select one of the availables:',
  'view.service.add_subtitle': '',
  'view.service.add_title': '',
  'view.service.add_widget_to_view': 'Add to Map',
  'view.service.select_view_widget':
    'If select any of services, you can add their widget to Map:',
  'view.tag': 'Tag',
  'view.thumbnail': 'Thumbnail',
  'widget.delete': 'Delete Widget',
  'widget.hide': 'Hide Widget',
  'widget.reg-search.geo-filter-result': 'Available Entities',
  'widget.reg-search.option.draw-region': 'Draw Region',
  'widget.reg-search.option.select-region': 'Select from Map',
  'widget.reg-search.settings.buffer_radius': 'Buffer(meter)',
  'widget.reg-search.settings.buffer_radius.info':
    'Buffer size for finding nearest from selected datasets.',
  'widget.reg-search.title': 'Zone Settings',
  'widget.reg-search.tooltip.buffer-side-both': 'Common Buffer',
  'widget.reg-search.tooltip.buffer-side-in': 'Inner Buffer',
  'widget.reg-search.tooltip.buffer-side-out': 'Outer Buffer',
  'widget.reg-search.tooltip.buffer-zone-diff': 'Buffer Zone',
  'widget.reg-search.tooltip.buffer-zone-in': 'Inner Zone',
  'widget.reg-search.tooltip.buffer-zone-out': 'Outer Zone',
  'widget.reg-search.change-zone': 'change search zone',
  'widget.search.filter-query-placeholder': 'filter query',
  'widget.search.intro': 'Search in this database',
  'widget.search.no-result-messge': 'no result found',
  'widget.search.no-result-submessge': '',
  'widget.search.searchfield': 'Search field',
  'widget.search.show_nearest': 'show nearest distance',
  'widget.search.show_nearest_air': 'show nearest air distance',
  'widget.search.show_nearest_route': 'show nearest route distance',
  'widget.search.similar_phrase': 'Search for similar phrases.',
  'widget.search.check_again': 'Check the parameters and filters again',
  'widget.unhide': 'Show Widget',
  widgets: 'Widgets',
  xlsx: 'xlsx',
  'scroll-to-top': 'Go up',

  'widgets.create.widget_name': 'Widget Name',
  'widgets.create.type.chart.bar': 'Bar chart',
  'widgets.create.type.chart.line': 'Line chart',
  'widgets.create.type.chart.pie': 'Pie chart',
};
